<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__gold" id="benefits_item__gold" @mouseover="onTrackHover">
      {{ $t('25 золота за каждые потраченные 100 RUB') }}
    </p>
    <p class="benefits_item benefits_item__farm-gold" id="benefits_item__farm-gold" @mouseover="onTrackHover">
      {{ $t('5% от стоимости покупок в Премиум магазине в виде золота') }}
    </p>
    <p class="benefits_item benefits_item__reserves" id="benefits_item__reserves" @mouseover="onTrackHover">
      {{ $t('54 личных резерва для ускорения прокачки') }}
    </p>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'

@Component
class BenefitsMtRu extends BenefitsBase {
}

export default BenefitsMtRu
</script>
